import { NextgenImage, useTranslation } from '@nextgen-web-framework/all';
import PortalModal from '../portal/Portal';
import styles from './OverlayLoader.module.scss';
const OverlayLoader = () => {
  const configs = ConfigService.getConfigs();
  const ASSETS_BASE_PATH = configs.NEXT_ASSETS_BASE_PATH as string;
  const t = useTranslation();

  return (
    <PortalModal elementId="react-portal-overlay" customStyles>
      <div className={styles['overlay-spinner']} data-testid="overlay-spinner-test-id">
        <NextgenImage src={`${ASSETS_BASE_PATH}/icons/Spinner.svg` ?? ''} alt={t('web.overlay.spinner.alt.title')} />
      </div>
    </PortalModal>
  );
};

export default OverlayLoader;
